/** @jsxImportSource @emotion/react */

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  DoubleArrow,
} from '@material-ui/icons'
import { getPages } from 'utils/pagination'
import { Skeleton } from 'ui-components/Skeleton'
import {
  revert,
  current,
  List,
  Item,
  ArrowButton,
  PageButton,
  Info,
} from './styles'

export default function Pagination(props) {
  const {
    onClick,
    pagination,
    showInfo,
    loading,
  } = props

  const [pages, setPages] = useState([])

  useEffect(() => {
    if (!pagination) return
    const paginate = getPages({
      current: pagination.current,
      total: pagination.pages,
    })

    setPages(paginate)
  }, [pagination])

  const handleClick = (page) => {
    if (page === pagination.current) return
    onClick(page)
  }

  const renderBackArrow = () => (
    <Item>
      <ArrowButton
        buttonType="icon"
        size="small"
        css={revert}
        onClick={() => handleClick(1)}
      >
        <DoubleArrow />
      </ArrowButton>
    </Item>
  )

  const renderPage = (page) => {
    if (page < 1 || page > pagination.pages) return null

    return (
      <Item key={`pagination-${page}`}>
        <PageButton
          buttonType="icon"
          onClick={() => handleClick(page)}
          css={pagination.current === page ? current : null}
        >
          {page}
        </PageButton>
      </Item>
    )
  }

  const renderForwardArrow = () => (
    <Item>
      <ArrowButton
        buttonType="icon"
        size="small"
        onClick={() => handleClick(pagination.pages)}
      >
        <DoubleArrow />
      </ArrowButton>
    </Item>
  )

  const renderInfo = () => (
    <Info>
      <div>
        {`${pagination.count} registros encontrados`}
      </div>
      <div>
        {`Total de ${pagination.pages} páginas`}
      </div>
    </Info>
  )

  if (loading) return <Skeleton variant="rect" height={41} />

  return pagination ? (
    <section>
      <nav>
        <List>
          {renderBackArrow()}
          {pages.map(renderPage)}
          {renderForwardArrow()}
        </List>
      </nav>
      { showInfo ? renderInfo() : null }
    </section>
  ) : null
}

Pagination.propTypes = {
  onClick: PropTypes.func.isRequired,
  pagination: PropTypes.exact({
    count: PropTypes.number,
    current: PropTypes.number,
    next: PropTypes.number,
    pages: PropTypes.number,
    per_page: PropTypes.number,
    previous: PropTypes.number,
  }),
  showInfo: PropTypes.bool,
  loading: PropTypes.bool,
}

Pagination.defaultProps = {
  pagination: null,
  showInfo: false,
  loading: false,
}
